import axios from 'axios';
import { getCache } from '@/utils/LocalCache';
import { TOKEN } from '@/utils/CacheKey';
import { ElMessage } from 'element-plus';
import router from '@/router';

const axiosInstance = axios.create({
    baseURL: '/restful',
    timeout: 100000,
    withCredentials: false,
});

// 请求拦截器：简化 Token 处理，增加空值判断
axiosInstance.interceptors.request.use((config) => {
    const tokenInfo = getCache(TOKEN);
    if (tokenInfo) {
        // 兼容 token 是对象或字符串的情况，避免解析报错
        const token = typeof tokenInfo === 'object' ? tokenInfo.token : tokenInfo;
        if (token) {
            config.headers['Token'] = token;
        }
    }
    return config;
}, (error) => {
    console.log("请求错误", error);
    ElMessage.error('请求发送失败，请检查网络');
    return Promise.reject(error);
});

// 响应拦截器：修复返回逻辑 + 变量名 + 提示语
axiosInstance.interceptors.response.use((response) => {
    // 移除无用的 data 解析逻辑（无加密场景下没必要）
    const { code, message } = response.data;

    // 无 code 时默认返回成功数据
    if (code == null) {
        return response; // 直接返回业务数据，方便前端使用
    }

    // 按状态码处理，每个分支都明确返回/拒绝
    switch (code) {
        case 0: // 成功状态码
            if (message && message !== 'OK') {
                ElMessage.success(message);
            }
            return response; // 返回解析后的数据，而非整个 response
        case 1: // 业务失败
            if (message && message !== 'OK') {
                ElMessage.success(message);
            }
            return response; // 返回解析后的数据，而非整个 response
        case 1001:
        case 401: // 登录失效
            ElMessage.error(message || '登录已失效，请重新登录');
            window.sessionStorage.clear();
            setTimeout(() => router.push('/login'), 1000); // 延时跳转，确保提示显示
            return Promise.reject(message || '登录失效');
        case 403: // 无权限
            ElMessage.error(message || '暂无权限访问');
            console.log("状态码403：", message);
            return Promise.reject(message || '暂无权限');
        default: // 其他状态码
            console.log('状态码未匹配默认输出', message);
            ElMessage.error(message || '请求处理异常'); // 修复 msg -> message
            return Promise.reject(message || '请求处理异常');
    }
}, (error) => {
    // 修复错误提示拼接问题，按不同错误类型提示
    if (error.response) {
        const status = error.response.status;
        if (status === 404) {
            ElMessage.error('请求的接口不存在');
            // router.push('/404'); // 可选：跳转到404页面
        } else if (status === 500) {
            ElMessage.error('服务器内部异常，请稍后重试');
        } else {
            ElMessage.error(`请求失败（状态码：${status}）`);
        }
    } else if (error.request) {
        ElMessage.error('网络异常，无法连接服务器');
    } else {
        ElMessage.error('请求配置错误：' + error.message);
    }
    console.error('响应异常详情：', error);
    return Promise.reject(error);
});

export default axiosInstance;